<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="cases"
        :server-items-length="totalCases"
        :footer-props="{itemsPerPageOptions: [10, 25, 40],
              showFirstLastPage: true}"
        :options.sync="innerPagination"
        :loading="progress('getCases')"
        class="elevation-1">
      <template slot="item" slot-scope="props">
        <tr :style="{'cursor': 'pointer'}" @click="handleCaseClickHandler(props.item.systemId)">
          <td>
            <div v-if="!props.item.allDocumentsReceived" class="not-all-documents-received">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <i v-on="on" class="fas fa-file-import"/>
                </template>
                <span>Documents not received</span>
              </v-tooltip>
            </div>{{ props.item.systemId }}
          </td>
          <td>{{ props.item.creationDatetime | DateWithMinutes }}</td>
          <td>
            <span v-if="props.item.aggregatedDaysLeft !== null"
                  v-bind:class="completionDatetimeClass(props.item)">
                {{ props.item.aggregatedDaysLeft }}
            </span>
            <span v-else>
                            -
                        </span>
            <v-tooltip bottom v-if="props.item.hasNotCompletedPrioritySamples">
              <template v-slot:activator="{ on }">
                <i v-on="on" class="fas fa-bolt high-priority"></i>
              </template>
              <span>Has high priority samples</span>
            </v-tooltip>
          </td>
          <!--                    <td>-->
          <!--                        <service-code-badges :servicesById="servicesById" :caseServices="props.item.services"/>-->
          <!--                    </td>-->
          <td>{{ props.item.patient.name | NoEmpty }}</td>
          <td>{{ clientName(props.item.clientId) }}</td>
          <td>
            <initials-list :items="clientSpecialistNames(props.item.clientId, props.item.clientSpecialistIds)"/>
          </td>
          <td>
                        <span
                            v-if="getLastReport(props.item) && getLastReport(props.item).status === 'sent' && props.item.samplesInWorkCount === 0">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                <span v-on="on" class="report-sent-label"><i
                                    class="fas fa-envelope-square"></i>&nbsp;{{
                                    props.item.lastReportSentAt | DateWithMinutes
                                  }}
                              </span>
                                </template>
                            Sent to client at {{ props.item.lastReportSentAt | DateWithMinutes }}
                        </v-tooltip>
                        </span>
            <span v-else>
                            <report-specialist-list :items="getLastReportSignedBy(props.item)"/>
                        </span>
          </td>
          <td>{{ props.item.samplesToAnalysisCount }}</td>
          <td>{{ getInBatches(props.item) }}</td>
          <td>
            <div class="samples-stat" v-if="props.item.samplesCountByStatuses['inWork']">
              {{ props.item.samplesCountByStatuses['inWork'] || 0 }} - in work
            </div>
            <div class="samples-stat" v-if="props.item.samplesCountByStatuses['reportCreated']">
              {{ props.item.samplesCountByStatuses['reportCreated'] || 0 }} - report created
            </div>
            <div class="samples-stat" v-if="props.item.samplesCountByStatuses['validation']">
              {{ props.item.samplesCountByStatuses['validation'] || 0 }} - validation
            </div>
            <div class="samples-stat" v-if="props.item.samplesCountByStatuses['validated']">
              {{ props.item.samplesCountByStatuses['validated'] || 0 }} - validated
            </div>
            <div class="samples-stat" v-if="props.item.samplesCountByStatuses['sent']">
              {{ props.item.samplesCountByStatuses['sent'] || 0 }} - sent
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import _ from 'lodash'
import NoEmpty from '../../Filters/NoEmpty.js'
import DateWithMinutes from '../../Filters/DateWithMinutes.js'
import Countdown from '../../Common/Countdown'
import InitialsList from '../../Common/InitialsList'
import ReportSpecialistList from './ReportSpecialistList'
import ServiceCodeBadges from '../../Services/Components/ServiceCodeBadges'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  name: 'List',
  props: {
    items: Array
  },
  components: {
    Countdown,
    ServiceCodeBadges,
    InitialsList,
    ReportSpecialistList
  },
  filters: {
    NoEmpty,
    DateWithMinutes
  },
  data() {
    return {
      headers: [
        {
          text: 'Id',
          align: 'left',
          value: 'systemId',
          width: '50px'
        },
        {
          text: 'Creation datetime',
          align: 'left',
          value: 'creationDatetime'
        },
        {
          text: 'Due days',
          align: 'left',
          value: 'sampleEstimatedCompletionDatetime'
        },
        // {
        //     text: 'Services',
        //     align: 'left',
        //     sortable: false,
        //     value: 'services'
        // },
        {
          text: 'Patient name',
          align: 'left',
          sortable: false,
          value: 'patientName',
          width: '220px'
        },
        {
          text: 'Client',
          align: 'left',
          sortable: false,
          value: 'client'
        },
        {
          text: 'Embriologist',
          align: 'left',
          sortable: false,
          value: 'clientSpecialist'
        },
        {
          text: 'Report',
          align: 'left',
          sortable: false,
          value: 'reportSignedBy'
        },
        {
          text: 'Samples count',
          align: 'left',
          sortable: false,
          value: 'samplesCount'
        },
        {
          text: 'In run',
          align: 'left',
          sortable: false,
          value: 'inBatches'
        },
        {
          text: 'Samples status',
          align: 'left',
          sortable: false,
          value: 'reportStatus'
        }
      ],
      innerPagination: {}
    }
  },
  computed: {
    ...mapState('pgtCases', {
      cases: 'cases',
      totalCases: 'totalCases',
      pagination: 'pagination'
    }),
    ...mapState('services', {
      servicesById: 'servicesById',
    }),
    ...mapGetters('clients', {
      clientsById: 'clientsById'
    }),
    ...mapGetters('pgtCases', {
      progress: 'progress',
      availableReportStatusesByValue: 'availableReportStatusesByValue'
    }),
    ...mapGetters({
      availableSpecialistsByIds: 'availableSpecialistsByIds'
    })
  },
  watch: {
    innerPagination: {
      async handler(pagination) {
        this.changePagination(pagination)
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('pgtCases', {
      getCases: 'getCases',
      changePagination: 'changePagination'
    }),
    completionDatetimeClass(c) {
      return {
        'overdued': c.aggregatedDaysLeft && c.aggregatedDaysLeft < 0
      }
    },
    serviceCode(serviceId) {
      return _.get(this.servicesById, [serviceId, 'code'], '-')
    },
    serviceTitle(serviceId) {
      return _.get(this.servicesById, [serviceId, 'title'], '-')
    },
    clientName(clientId) {
      return _.get(this.clientsById, [clientId, 'title'], '-')
    },
    clientSpecialistNames(clientId, clientSpecialistIds) {
      const clientSpecialists = _.get(this.clientsById, [clientId, 'specialists'], [])
      let names = []

      if (clientSpecialistIds === null) {
        return names
      }

      for (let clientSpecialistId of clientSpecialistIds) {
        const clientSpecialistIndex = _.findIndex(clientSpecialists, function (specialist) {
          return specialist.id === clientSpecialistId
        })

        if (clientSpecialistIndex < 0) {
          continue
        }

        const name = _.get(clientSpecialists, [clientSpecialistIndex, 'name'], null)

        if (name === null) {
          continue
        }

        names.push(name)
      }

      return names
    },
    handleCaseClickHandler(caseId) {
      this.$router.push({
        path: `/cases/pgt/update/${caseId}`
      })
    },
    getLastReport(c) {
      const reports = _.get(c, 'reports', [])

      if (!reports || reports.length === 0) {
        return null
      }

      return reports[reports.length - 1]
    },
    getLastReportSignedBy(c) {
      const lastReport = this.getLastReport(c)

      if (!lastReport) {
        return []
      }

      if (lastReport.status === 'sent') {
        return []
      }

      const specialistsSignatures = _.get(lastReport, 'specialists', [])

      let resultSpecialists = []

      for (let specialistSignature of specialistsSignatures) {
        const s = _.get(this.availableSpecialistsByIds, specialistSignature.id, null)

        if (!s) {
          continue
        }

        resultSpecialists.push({
          id: s.id,
          name: s.name,
          signed: specialistSignature.signed
        })
      }

      return resultSpecialists
    },
    getLastReportStatus(c) {
      const lastReport = this.getLastReport(c)

      if (!lastReport) {
        return '-'
      }

      return _.get(this.availableReportStatusesByValue, [lastReport.status, 'title'], '-')
    },
    getInBatches(c) {
      const filteredSamples = _.filter(_.get(c, 'samples', []), (item) => {
        return item.analysisComplete === false && item.batchId && item.target === 'analysis'
      })

      const batchSystemIds = _.uniq(_.map(filteredSamples, 'batchSystemId'))

      if (batchSystemIds.length === 0) {
        return '-'
      }

      return _.join(batchSystemIds, ', ')
    }
  },
  mounted() {
    this.innerPagination = _.cloneDeep(this.pagination)
    this.getCases()
  }
}
</script>

<style scoped>
.report-sent-label {
  white-space: nowrap;
}

.overdued {
  color: #c51a1a;
}

.high-priority {
  color: red;
}

.samples-stat {
  font-size: 11px;
}

.not-all-documents-received i {
  color: red;
  position: absolute;
  margin-top: 3px;
  margin-left: -25px;
}

</style>